import { render, staticRenderFns } from "./Seminars.vue?vue&type=template&id=b57ae174&scoped=true&"
import script from "./Seminars.vue?vue&type=script&lang=js&"
export * from "./Seminars.vue?vue&type=script&lang=js&"
import style0 from "./Seminars.vue?vue&type=style&index=0&id=b57ae174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57ae174",
  null
  
)

export default component.exports